import { tv } from '../../lib/tv';

/**
 * The Figma Tooltip (Controls ↳ Tooltip, 48:361): a bg/inverse "Body" with
 * 6/12 padding, radius/sm and Shadow/MD, Body/Small text/inverse, wrapping at
 * 240px (Length=Long), plus a 12×6 bg/inverse "Arrow" pointing at the trigger.
 * Shared by the Radix TooltipContent and the static Figma-frame story.
 */
export const tooltipStyles = tv({
  slots: {
    content: [
      'bg-bg-inverse text-text-inverse text-body-sm z-50 w-fit max-w-60 rounded-sm px-3 py-1.5 shadow-md',
      'origin-(--radix-tooltip-content-transform-origin)',
      'animate-in fade-in-0 zoom-in-95',
      'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
    ],
    arrow: 'fill-bg-inverse',
  },
});

/** Figma Tooltip delays: 400ms in, 0ms out. */
export const TOOLTIP_DELAY = 400;
